import { render, staticRenderFns } from "./customerCreate.vue?vue&type=template&id=12c50e9e"
import script from "./customerCreate.vue?vue&type=script&lang=js"
export * from "./customerCreate.vue?vue&type=script&lang=js"
import style0 from "./customerCreate.vue?vue&type=style&index=0&id=12c50e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports